



























import * as Util from '@/util.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';

interface EstablishmentLocationToPick extends EstablishmentLocation {
  notOpen: boolean;
  distanceFromUser?: number;
}

export default Vue.extend({
  data() {
    return {
      showModeSelection: false,
      onlyOneChoice: false,
      currLocation: null,
      locationIdBase36: '',
    };
  },
  computed: {
    locationsToPickFrom(): EstablishmentLocationToPick[] {
      const locationsToPickFrom: EstablishmentLocationToPick[] = this.$store.state.locationsToPickFrom.map((location: EstablishmentLocation) => {
        const availabilities = Util.getAvailibilitiesForLocation(location);
        const locationCopy: EstablishmentLocationToPick = {
          ...location,
          notOpen: availabilities.cannotOrderTakeoutOrDelivery,
        };
        return locationCopy;
      });
      return locationsToPickFrom;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {
    locationsToPickFrom() {
      this.onLoad();
    },
  },
  methods: {
    formatDistance(distance: number) {
      return distance.toFixed(2) + 'km';
    },
    onLoad() {
      if (this.locationsToPickFrom?.length > 1) {
        Util.getUserLocation(Util.t?.requestingLocationForLocationSorting).then((coods) => {
          if (coods) {
            this.locationsToPickFrom.forEach((location: EstablishmentLocationToPick) => {
              const coodsArray: [number, number] = [coods.latitude, coods.longitude];
              location.distanceFromUser = Util.getDistanceBetweenPoints(coodsArray, [location.latitude as number, location.longitude as number]);
            });
            this.locationsToPickFrom.sort((a: EstablishmentLocationToPick, b: EstablishmentLocationToPick) => {
              return (a.distanceFromUser as number) - (b.distanceFromUser as number); // Sort notifications by date in descending fashion.
            });
            this.$forceUpdate();
          }
        });
      } else if (this.locationsToPickFrom?.length === 1) {
        this.$data.onlyOneChoice = true;
        this.onLocationPicked(this.locationsToPickFrom[0]);
      }
    },
    timeSlotsToString(timeSlots: TimeSlot[]) {
      return Util.timeSlotsToString(timeSlots);
    },
    shortAddress(longAddress: string): string {
      const parts = longAddress.split(',');
      return `${parts[0]}, ${parts[1]}`;
    },
    onLocationPicked(location: EstablishmentLocationToPick) {
      const locationCopy = { ...location };
      delete locationCopy.notOpen;
      this.$store.commit('setCurrentLocation', locationCopy);
      this.$data.showModeSelection = true;
    },
  },
});
